import { gql } from '@apollo/client'

export const GET_LABELING_STATISTICS = gql`
  query LabelingStatistics(
    $startDate: Date
    $endDate: Date
    $granularity: StatsGranularity
  ) {
    labelingStatistics(
      startDate: $startDate
      endDate: $endDate
      granularity: $granularity
    ) {
      classification {
        batches {
          bucketSize
          series {
            email
            results {
              dateString
              count
            }
          }
        }
        crops {
          bucketSize
          series {
            email
            results {
              dateString
              count
            }
          }
        }
      }
      detection {
        boxes {
          bucketSize
          series {
            email
            results {
              dateString
              count
            }
          }
        }
        images {
          bucketSize
          series {
            email
            results {
              dateString
              count
            }
          }
        }
      }
      correction {
        corrections {
          bucketSize
          series {
            email
            results {
              dateString
              count
            }
          }
        }
      }
    }
  }
`
